import { render, staticRenderFns } from "./choseClass.vue?vue&type=template&id=6cfb78ee&scoped=true&"
import script from "./choseClass.js?vue&type=script&lang=js&"
export * from "./choseClass.js?vue&type=script&lang=js&"
import style0 from "./choseClass.vue?vue&type=style&index=0&id=6cfb78ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfb78ee",
  null
  
)

export default component.exports